import Vue from 'vue';
import Multiselect from 'vue-multiselect';

Vue.component('Multiselect', Multiselect);
